<template>
    <div class="loading-wrapper">
        <span>{{ text }} ...</span>
        <a-progress :showInfo="false" :percent="successedPercent" status="active" />
    </div>
</template>

<script>
const firstRandomPercent = Math.floor(Math.random() * 10) + 60;
export default {
    name: "CbDashboardProgressBar",
    props: {
        isReady: Boolean,
        text: {
            type: String,
            default: "Chatbot Story Loading ...",
        },
    },
    data() {
        return {
            successedPercent: 0,
            isCompletedFirstPercentLevel: false,
        };
    },
    methods: {
        startToSuccess() {
            const intervalId = setInterval(() => {
                if (!this.isCompletedFirstPercentLevel) {
                    if (this.successedPercent < firstRandomPercent) {
                        this.successedPercent = this.successedPercent + Math.floor(Math.random() * 24) + 10;
                    } else {
                        this.isCompletedFirstPercentLevel = true;
                    }
                } else {
                    if (this.successedPercent < 95)
                        this.successedPercent = this.successedPercent + Math.floor(Math.random() * 4) + 1;
                    else {
                        this.successedPercent = 99;
                        // clearInterval(intervalId);
                    }
                }
            }, 400);
            this.intervalId = intervalId;
        },
    },
    mounted() {
        this.startToSuccess();
    },
    beforeDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
};
</script>

<style lang="scss">
.loading-wrapper {
    position: fixed;
    width: 100%;
    height: 100vh !important;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    span {
        letter-spacing: 3px;
        font-width: 700;
        color: var(--default-text-color);
    }

    .ant-progress {
        margin-top: 5px;
        width: 85vw;
    }
}
</style>
